import { useState } from "react";
import { useDrop } from "react-dnd";
import { useDispatch } from "react-redux";
import { api } from "../../features/api/api";
import {
    useGetProjectsQuery,
    useUpdateProjectPositionMutation,
} from "../../features/project/projectApi";
import projectLength from "../../utils/projectLength";
import ProjectModal from "../ui/ProjectModal";
import ProjectCard from "./../ui/ProjectCard";

export default function BackLogs() {
    const dispatch = useDispatch();
    // project modal state
    const [isProjectModalOpened, setProjectModalOpened] = useState(false);
    // get projects api
    const {
        data: getProjects,
        isLoading,
        isError,
    } = useGetProjectsQuery() || [];
    const [updateProjectPositionApi] = useUpdateProjectPositionMutation();

    // close project modal
    const closeHandler = () => {
        setProjectModalOpened(false);
    };
    // open project modal
    const addProjectHandler = () => {
        setProjectModalOpened(true);
    };

    let content;
    if (isLoading && !isError)
        content = <p className="text-green-700">Loading...</p>;
    if (!isLoading && isError)
        content = <p className="text-red-700">Something wrong</p>;
    if (!isLoading && !isError && getProjects?.length > 0) {
        content = getProjects
            ?.filter((project) => project.position === "backlog")
            .map((project) => (
                <ProjectCard key={project.id} project={project} />
            ));
    }
    if (!isLoading && !isError && getProjects?.length === 0) {
        content = <p className="text-red-700">Project is empty!</p>;
    }

    // dnd code
    const [{ isOver }, drop] = useDrop(() => ({
        accept: "PROJECT_STAGE_CHANGE",
        drop: (item, monitor) => ready(item.id),
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
        }),
    }));

    const ready = (id) => {
        dispatch(
            api.util.updateQueryData("getProjects", undefined, (draft) => {
                const project = draft.find((project) => project.id === id);
                project.position = "backlog";
            })
        );
        updateProjectPositionApi({
            id,
            position: "backlog",
        });
    };

    return (
        <>
            <div className="flex flex-col flex-shrink-0 w-72">
                <div className="flex items-center flex-shrink-0 h-10 px-2">
                    <span className="block text-sm font-semibold">Backlog</span>
                    <span className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
                        {projectLength(getProjects, "backlog")}
                    </span>
                    <button
                        onClick={addProjectHandler}
                        className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div
                    className={`flex flex-col pb-2 overflow-auto h-screen px-2 ${
                        isOver && "border-dashed border-spacing-3 border-2"
                    }`}
                    ref={drop}
                >
                    {content}
                </div>
            </div>
            {isProjectModalOpened && (
                <ProjectModal
                    close={closeHandler}
                    state={setProjectModalOpened}
                />
            )}
        </>
    );
}
